<template>
  <div>
    <el-dialog v-model="drawingBoardShow" title="画板" width="500" :show-close="false" 
               :align-center="true" :close-on-click-modal="false" @closed="handleDialogClosed">
      <template #header>
        <div class="dialog-header">
          <span class="header-title">画板</span>
          <div class="close_icon" @click="closePopup">
            <el-icon :size="20">
              <CloseBold />
            </el-icon>
          </div>
        </div>
      </template>
      
      <div class="dialog_content">
        <handWrite ref="handWrite"></handWrite>
      </div>
      
      <template #footer>
        <div class="dialog-footer">
          <el-button @click="closePopup">取消</el-button>
          <el-button type="primary" @click="saveDrawing">保存到编辑器</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import handWrite from "@/components/handWrite/index.vue"
export default {
  name: 'GjkcH5DrawingBoard',
  components: { handWrite },
  props: {
    // 可以接收编辑器实例
    // editorInstance: {
    //   type: Object,
    //   default: null
    // }
  },
  emits: ['save-image'], // 声明发射的事件

  data() {
    return {
      drawingBoardShow: false,
    };
  },

  watch: {
    drawingBoardShow(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          // 调用画板组件的resizeCanvas方法(解决实际绘制区域与鼠标区域有偏差的问题)
          if (this.$refs.handWrite && this.$refs.handWrite.resizeCanvas) {
            this.$refs.handWrite.resizeCanvas();
          }
        });
      }
    }
  },

  methods: {
    // 打开画板弹窗
    openDrawingBoard() {
      this.drawingBoardShow = true;
    },
    
    closePopup() {
      this.drawingBoardShow = false;
    },
    
    // 处理弹窗关闭
    handleDialogClosed() {
      // 可以在这里做一些清理工作
    },
    
    // 保存绘图
    saveDrawing() {
      if (this.$refs.handWrite && this.$refs.handWrite.save) {
        // 调用画板组件的保存方法
        this.$refs.handWrite.save();
        
        // 获取保存的图片数据
        const imageData = this.$refs.handWrite.savedImageUrl;
        if (imageData) {
          // 发射保存图片事件
          this.$emit('save-image', imageData);
          this.closePopup();
        } else {
          this.$message.warning('请先绘制内容');
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
:deep(.el-dialog) {
  box-shadow: 0px 0px 20px 0px rgba(0, 0, 0, 0.06);
  border-radius: 10px;
  padding: 0;
  width: 1200px;
  height: 920px;
  position: relative;
}

:deep(.el-dialog__header) {
  position: relative;
  padding: 0;
  margin: 0;
  box-sizing: border-box;
  text-align: start;
}

.dialog-header {
  position: relative;
  padding: 0 20px;
  height: 60px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border-bottom: 1px solid rgba(36, 35, 36, 0.1);
}

.header-title {
  font-size: 20px;
  color: #333333;
  font-weight: bold;
}

.close_icon {
  color: #333333;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #f5f5f5;
  }
}

.dialog_content {
  position: relative;
  text-align: center;
  height: calc(100% - 120px); /* 减去头部和底部的高度 */
  // padding: 20px;
  box-sizing: border-box;
}

:deep(.el-dialog__body) {
  padding: 0;
  height: calc(100% - 120px);
}

.dialog-footer {
  padding: 0 20px 10px;
  text-align: right;
}
</style>